import { Typography } from "@mui/material";
import { FunctionComponent } from "react";
import { DisableCheckIcon, DoneLightIcon, DoneDarkIcon } from "../../icon";

interface Props {
    Feature: string
    Index: number;
    DisabledIcon?: boolean;
}

const PlanFeatureComponent: FunctionComponent<Props> = (props) => {
    return <span className={`d-inline-flex`}>
        {props.DisabledIcon ? <DisableCheckIcon className='mr-1' /> : (props.Index % 2 === 1) ? <DoneLightIcon className='mr-1' /> : <DoneDarkIcon className='mr-1' />}
        <Typography className={`h5-regular d-block ${props.DisabledIcon ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : ''}`}>{props.Feature}</Typography>
    </span>
}

export default PlanFeatureComponent;